import React from "react";

const PlaycanvasContext = React.createContext(null);

export default PlaycanvasContext;